/** Canonical destinations retain the business subject and never trust an external return URL. */
export function workspaceDestination(path: string, search = ''): string | null {
 const parameters = new URLSearchParams(search);
 const views: Record<string,string> = { '/saisie-kpi':'actions', '/certification-kpi':'validation', '/import-kpi':'imports', '/signaux':'signals', '/kpis/nouveau':'reference' };
 if (path === '/collaboration') { const inbox = parameters.get('view') ?? 'mine'; parameters.set('exchangeView', inbox); parameters.set('view','exchanges'); return `/mon-espace?${parameters}`; }
 if (path === '/prerequis') { parameters.set('tab','prerequisites'); parameters.set('view',parameters.has('observation') ? 'actions' : 'validation'); if (!parameters.has('observation')) parameters.set('action','prerequisite'); return `/mon-espace?${parameters}`; }
 if (!views[path]) return null;
 if (!parameters.has('view')) parameters.set('view',views[path]);
 if(path==='/certification-kpi'&&!parameters.has('action'))parameters.set('action','review');
 if(path==='/certification-kpi'&&parameters.has('kpi')&&!parameters.has('search'))parameters.set('search',parameters.get('kpi')!);
 if(path==='/kpis/nouveau')parameters.set('create','1');
 if(path==='/import-kpi'&&!parameters.has('import'))parameters.set('import',parameters.get('mode')==='configuration'?'configuration':'values');
 return `/mon-espace?${parameters}`;
}

/** Legacy deep links remain valid; states and tools are not primary destinations. */
export function workspaceSection(view: string): string {
 if (['overview','actions','validation','signals'].includes(view)) return 'actions';
 if (['dossiers','drafts','calendar','imports'].includes(view)) return 'dossiers';
 if (view === 'reference') return 'indicators';
 return view;
}
export function workspaceReturn(raw: string | null): string | null {
 if (!raw || !raw.startsWith('/mon-espace?') || raw.length > 4000) return null;
 const url = new URL(raw, 'https://workspace.invalid');
 if (url.pathname !== '/mon-espace') return null;
 url.searchParams.delete('returnTo');
 return url.pathname + url.search;
}
